import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './layouts/admin/admin.component';
import { AuthComponent } from './layouts/auth/auth.component';
import { AuthGuard } from './guard/auth.guard';
import { SetupAuthGuard } from './setupGuard/auth.guard';
import { AddCatComponent } from './pages/add-cat/add-cat.component';
import { SupportComponent } from './pages/support/support.component';
import { PolicyComponent } from './pages/policy/policy.component';
const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'admin-dashboard',
        pathMatch: 'full'
      },
      {
        path: 'addCat',
        loadChildren: () => import('./pages/add-cat/add-cat.module').then(m => m.AddCatModule),
        canActivate: [AuthGuard]
      }, 
      {
        path: 'admin-dashboard',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard]
      }, 
      {
        path: 'basic',
        loadChildren: () => import('./components/basic/basic.module').then(m => m.BasicModule),
        canActivate: [AuthGuard]
      }, {
        path: 'notifications',
        loadChildren: () => import('./components/advance/notifications/notifications.module').then(m => m.NotificationsModule),
        canActivate: [AuthGuard]
      }, {
        path: 'forms',
        loadChildren: () => import('./components/forms/basic-elements/basic-elements.module').then(m => m.BasicElementsModule)
      }, {
        path: 'bootstrap-table',
        loadChildren: () => import('./components/tables/bootstrap-table/basic-bootstrap/basic-bootstrap.module').
          then(m => m.BasicBootstrapModule),
      },
      {
        path: 'simple-page',
        loadChildren: () => import('./simple-page/simple-page.module').then(m => m.SimplePageModule)
      },
      {
        path: 'admin-users',
        loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admin-banners',
        loadChildren: () => import('./banners/banners.module').then(m => m.BannersModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admin-notification',
        loadChildren: () => import('./notification/notification.module').then(m => m.NotificationModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admin-setting',
        loadChildren: () => import('./settings/restdetails.module').then(m => m.RestdetailsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admin-support',
        loadChildren: () => import('./supports/supports.module').then(m => m.SupportsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admin-chats',
        loadChildren: () => import('./chats/chats.module').then(m => m.ChatsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admin-newbanner',
        loadChildren: () => import('./newbanner/newbanner.module').then(m => m.NewbannerModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admin-newCate',
        loadChildren: () => import('./newdriver/newdriver.module').then(m => m.NewdriverModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admin-userdetails',
        loadChildren: () => import('./userdetails/userdetails.module').then(m => m.UserdetailsModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'ads-details',
        loadChildren: () => import('./AdsDetails/orderdetails.module').then(m => m.OrderdetailsModule),
        canActivate: [AuthGuard]
      }
      //
    ],

  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
        canActivate: [SetupAuthGuard]
      }, {
        path: 'report',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
      },
      {
        path: 'setup',
        loadChildren: () => import('./setup/setup.module').then(m => m.SetupModule)
      },
    ]
  },
  {
    path:'supporting',
    component:SupportComponent
  },
  {
    path:'policy',
    component:PolicyComponent
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
